import { createSelector } from "@ngrx/store";

import { selectRouter, selectIsSessionSwisscomHealthOrgAdminWrite } from "@core/store";
import {
  MyOrganizationState,
  Organization,
  organizationAdapter,
  OrganizationState
} from "@organizations/models";
import { organizationsReducer, selectMyOrganizationsState } from "@organizations/store/reducers";

const { selectEntities, selectAll } = organizationAdapter.getSelectors();

export const selectOrganizationsState = createSelector(
  selectMyOrganizationsState,
  (state: MyOrganizationState) => state.organizations as OrganizationState
);

export const selectOrganizationEntities = createSelector(selectOrganizationsState, selectEntities);
export const selectAllOrganizations = createSelector(selectOrganizationsState, selectAll);

export const selectCurrentOrganization = createSelector(
  selectOrganizationEntities,
  selectRouter,
  (organizations, router): Organization | undefined => {
    const organizationId = router?.params?.organizationId;

    if (organizationId) {
      return organizations[organizationId];
    }

    return undefined;
  }
);

export const selectOrganizationsLoading = createSelector(
  selectOrganizationsState,
  organizationsReducer.getOrganizationsLoading
);

export const selectOrganizationsLoaded = createSelector(
  selectOrganizationsState,
  organizationsReducer.getOrganizationsLoaded
);

export const selectOrganizationNameById = (entityId: string) =>
  createSelector(selectOrganizationEntities, (entities) => entities[entityId]!.name);

export const selectOrganizationById = (entityId: string) =>
  createSelector(selectOrganizationEntities, (entities) => entities[entityId]);

// Combined selector for header navigation data
export const selectHeaderNavigationData = createSelector(
  selectCurrentOrganization,
  selectIsSessionSwisscomHealthOrgAdminWrite,
  (organization, isAdmin) => ({
    organization,
    isAdmin
  })
);
